export const primaryColor = '#887ED8';

export const secondColor = '#F2825F';

export const darkerSecondColor = '#4aa861';

export const thirdColor = '#E9E561';

export const neutralColor = '#F5F5F5';

export const darkerNeutralColor = '#786C5E';

export const lightOrange = '#fcc4b3';

export const negativeColor = '#f9410e'